import { useEffect, useState } from "react";

const storageKey = "uat-qr-flow-overlay-visible";
const changedEvent = "qr-overlay-visibility-changed";
const readPreference = () => {
  try { return window.localStorage.getItem(storageKey) === "true"; }
  catch { return false; }
};

export default function useQrOverlayVisibility() {
  const [visible, setVisible] = useState(readPreference);
  useEffect(() => {
    const changed = event => setVisible(event.detail);
    const stored = event => {
      if (event.key === storageKey || event.key === null) setVisible(readPreference());
    };
    window.addEventListener(changedEvent, changed);
    window.addEventListener("storage", stored);
    return () => {
      window.removeEventListener(changedEvent, changed);
      window.removeEventListener("storage", stored);
    };
  }, []);

  const update = value => {
    try { window.localStorage.setItem(storageKey, String(value)); } catch { /* Keep the current-page preference when storage is unavailable. */ }
    window.dispatchEvent(new CustomEvent(changedEvent, { detail: value }));
  };
  return [visible, update];
}
